import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            <h2>Welcome to Dashboard</h2>
        </div>
    );
};

export default DashboardHome;